<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <search-part :bizTypes="bizTypes" @search="search" ref="searchPart"/>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="5" style="padding-left: 2px">
            货主/订单号
          </el-col>
          <el-col :span="2">业务类型</el-col>
          <el-col :span="5">去向单位/订单号</el-col>
          <el-col :span="5">货品</el-col>
          <el-col :span="2">数量</el-col>
          <el-col :span="3">批号</el-col>
          <el-col :span="2">状态</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!goodsList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="['status-no',{'active':currentItemId===item.orderDetailId}]" :key="item.orderDetailId"
               @click.prevent="showItem(item)"
               class="order-list-item order-list-item-bg order-list--no is-pointer"
               v-for="(item, index) in goodsList">
            <el-row>
              <el-col :span="5">
                <div class="f-grey">
                  {{item.orderNo }}
                </div>
                <div>
                  {{item.upstreamOrgName }}
                </div>
              </el-col>
              <el-col :span="2">
                <div>
                  <dict :dict-key="item.bizType" dict-group="bspBizType"></dict>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-grey" v-show="item.orderThirdNo">{{item.orderThirdNo }}</div>
                <div v-show="item.downstreamOrgName">{{item.downstreamOrgName}}</div>
              </el-col>
              <el-col :span="5">
                <div>{{item.goodsName}}</div>
                <div class="f-grey">{{item.specification}}</div>
              </el-col>
              <el-col :span="2">
                <div>{{item.orderAmount}}</div>
              </el-col>
              <el-col :span="3">
                {{item.batchNumber}}
              </el-col>
              <el-col :span="2">
                {{getOrderStatus(item)}}
              </el-col>
            </el-row>
            <!--<div class="order-list-item-bg"></div>-->
          </div>
        </div>
      </div>
      <div class="text-center" v-show="goodsList.length && !loadingData">
        <el-pagination
          :current-page="pager.currentPage"
          :page-sizes="[10,20,50,100]" :pageSize="pager.pageSize" :total="pager.count"
          @current-change="handleCurrentChange" @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>

    <page-right :css="{'width':'800px','padding':0}" :show="showDetailPart" @right-close="resetRightBox">
      <detail :currentItem="currentItem" :getOrderStatus="getOrderStatus" @close="resetRightBox"></detail>
    </page-right>
  </div>
</template>
<script type="text/jsx">
  import {BSPOrder} from '@/resources';
  import detail from './detail.vue';
  import validMixin from '@/mixins/vaildMixin';
  import SearchPart from './search';
  import orderMixin from '@/mixins/orderMixin';
  import utils from '@/tools/utils';

  export default {
    components: {detail, SearchPart},
    mixins: [validMixin, orderMixin],
    data() {
      return {
        loadingData: true,
        showDetailPart: false,
        orgType: {},
        filters: {},
        goodsList: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 10
        },
        currentItemId: '',
        currentItem: {}
      };
    },
    mounted() {
      this.orgType = utils[this.type === 0 ? 'inBspOrderType' : 'outBspOrderType'];
      this.getGoodsList(1);
    },
    watch: {
      role() {
        this.$refs.searchPart.resetSearchForm();
      },
      type() {
        this.orgType = utils[this.type === 0 ? 'inBspOrderType' : 'outBspOrderType'];
        this.getGoodsList(1);
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getGoodsList(1);
      },
      handleCurrentChange(val) {
        this.getGoodsList(val);
      },
      getGoodsList(pageNo) {
        this.goodsList = [];
        let params = Object.assign({}, this.filters, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        });
        this.loadingData = true;
        this.time = Date.now();
        const time = this.time;
        BSPOrder[this.isPlatForm ? 'queryOutGoodsList' : 'queryOutOrgGoodsList'](params).then(res => {
          if (time < this.time) return;
          this.goodsList = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      showItem(item) {
        this.currentItemId = item.orderDetailId;
        this.currentItem = item;
        this.showDetailPart = true;
      },
      resetRightBox() {
        this.showDetailPart = false;
      },
      search(val) {
        Object.assign(this.filters, val);
        this.getGoodsList(1);
      },
      getOrderStatus: function (order) {
        let status = '';
        for (let key in this.orgType) {
          if (order.orderStatus === this.orgType[key].status) {
            status = this.orgType[key].title;
          }
        }
        return status;
      }
    }
  };
</script>
